import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import {FaQuestion} from 'react-icons/fa';
import {IoMdPause, IoMdPlay} from 'react-icons/io';
import {useFirebaseAuthUserStore} from '../../stores/FirebaseAuthUserStore';
import {ASCIIArt} from '../ASCIIArt';
import {GoogleSigninButton} from './GoogleSigninButton';
import {NavbarButton} from './NavbarButton';

const style = {
	aboutButton: `fixed top-12 recommended:top-16 left-20 recommended:left-32 z-10   flex justify-center items-center   w-8 recommended:w-10 h-8 recommended:h-10   text-whirlwindLightest hover:text-whirlwindLight text-xl recommended:text-2xl   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   rounded-md   opacity-80`,
	header: `fixed top-0 z-20   flex flex-col   w-full h-24 recommended:h-32   bg-whirlwindDarkest`,
	marquee: `fixed   h-24 recommended:h-28   text-whirlwindPrimaryLight`,
	marqueePlayButton: `fixed top-12 recommended:top-16 left-10 recommended:left-20 z-10   flex justify-center items-center   w-8 recommended:w-10 h-8 recommended:h-10   text-whirlwindLightest hover:text-whirlwindLight text-xl recommended:text-2xl   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   rounded-md   opacity-80`,
	navbar: `fixed top-24 recommended:top-32   flex flex-row   pb-5   w-full h-12   bg-gradient-to-b from-[83.33%] from-whirlwindDarkest to-[83.33%] to-whirlwindPrimaryDarkest`,
	navLinkButton: `flex basis-1/2   h-10`,
};

export const Navbar = () => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);

	// Component variables
	const [play, setPlay] = useState(true);

	return (
		<header className={style.header}>
			<div id="marquee">
				<Marquee className={style.marquee} play={play} speed={20}>
					<NavLink to="/">
						<ASCIIArt
							dataTestId={`marquee`}
							tailwindcss
							text={`whirlwind   whirlwind   whirlwind   whirlwind   whirlwind   whirlwind   `}
						/>
					</NavLink>
				</Marquee>
				<button
					className={style.marqueePlayButton}
					data-test-id={`marqueeASCIIArtPauseButton_TEST`}
					data-test-play={play}
					onClick={() => setPlay(!play)}>
					{play ? <IoMdPause /> : <IoMdPlay />}
				</button>
				<NavLink to="/about">
					<div className={style.aboutButton}>
						<FaQuestion />
					</div>
				</NavLink>
			</div>
			<nav className={style.navbar}>
				<div className={style.navLinkButton}>
					<NavbarButton
						extendcss="border-r-2"
						id="communityNavbarButton"
						route="/community"
						textContent="Community"
					/>
				</div>
				<div className={style.navLinkButton}>
					{firebaseAuthUser ? (
						<NavbarButton
							extendcss="border-l-2"
							id="accountNavbarButton"
							route="/account"
							textContent="Account"
						/>
					) : (
						<GoogleSigninButton />
					)}
				</div>
			</nav>
		</header>
	);
};
